module.exports = __webpack_public_path__ + "static/media/0002.d39c1db2.jpg";